'use client';

interface SliderControlProps {
    label: string;
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
    unit?: string;
    step?: number;
}

export default function SliderControl({
    label,
    min,
    max,
    value,
    onChange,
    unit = '',
    step = 1,
}: SliderControlProps) {
    return (
        <div className="flex flex-col gap-2">
            <label className="text-[11px] font-medium uppercase tracking-[0.05em] text-muted">
                {label}
            </label>
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={Math.min(max, Math.max(min, value))}
                onChange={(e) => onChange(parseFloat(e.target.value))}
                className="w-full"
            />
            <div className="flex items-center gap-1">
                <input
                    type="number"
                    min={min}
                    step={step}
                    value={value}
                    onChange={(e) => {
                        const v = parseFloat(e.target.value);
                        if (!isNaN(v) && v >= min) onChange(v);
                    }}
                    className="w-16 rounded-sm border-[0.5px] border-line bg-page px-1.5 py-0.5 text-right text-[13px] text-ink"
                />
                {unit && <span className="text-[13px] text-muted">{unit}</span>}
            </div>
        </div>
    );
}
